import React from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Footer from "./footer";

const FooterDesktop = () => {
  return (
    <React.Fragment>
      <Row
        alignmentHorizontal="start"
        spacingInset="600 600 600 none"
        widths={["grid-2", "grid-8"]}
        backgroundColor="#EFEFEF"
      >
        <Column></Column>
        <Footer></Footer>
      </Row>
    </React.Fragment>
  );
};

export default FooterDesktop;
